// extracted by mini-css-extract-plugin
module.exports = {"intentsList":"intents-list_intentsList__b4VJt","add":"intents-list_add__1lSmb","intents":"intents-list_intents__10Xx3","intent":"intents-list_intent__2m2BC"};